module.exports = __webpack_public_path__ + "static/Oswald-Medium-721a99b232bc730f6007eebd2b9aac64.woff";